import type { KeyValueStorage } from "@luckymenu/staff-core";

const DB_NAME = "luckymenu";
const STORE = "kv";

function request<T>(req: IDBRequest<T>): Promise<T> {
	return new Promise((resolve, reject) => {
		req.onsuccess = () => resolve(req.result);
		req.onerror = () => reject(req.error);
	});
}

/**
 * The staff-core storage adapter on IndexedDB: one object store of strings.
 * Survives reloads, which keeps carts and drafts (UX rule 4).
 */
export function indexedDbStorage(factory: IDBFactory = indexedDB): KeyValueStorage {
	let db: Promise<IDBDatabase> | null = null;
	const open = () => {
		db ??= new Promise((resolve, reject) => {
			const req = factory.open(DB_NAME, 1);
			req.onupgradeneeded = () => req.result.createObjectStore(STORE);
			req.onsuccess = () => resolve(req.result);
			req.onerror = () => reject(req.error);
		});
		return db;
	};
	const store = async (mode: IDBTransactionMode) =>
		(await open()).transaction(STORE, mode).objectStore(STORE);

	return {
		async getItem(key) {
			const value = await request((await store("readonly")).get(key));
			return typeof value === "string" ? value : null;
		},
		async setItem(key, value) {
			await request((await store("readwrite")).put(value, key));
		},
		async removeItem(key) {
			await request((await store("readwrite")).delete(key));
		},
	};
}
